/* Makeup Geek: free gift on orders of EUR 100+ (Black Friday Month).
   Adds the Charlotte Tilbury Magic Mini Brush Set when the spend reaches EUR 100. The automatic discount "Black Friday: FREE Magic Mini
   Brush Set" makes it EUR 0.00. If the gift is ever not free after adding it, it is removed again, so nobody pays for it by surprise.
   Removes the gift again when the spend drops below EUR 100 and respects a customer who removes it by hand.
   Progress bar markup: snippets/mg-bf-progress.liquid. Ends 30 Nov 2026 23:59 Paris time (same as the discounts). */
(function () {
  var GIFT_VARIANT = 59200926056783;
  var THRESHOLD = 10000;
  var END = 1796079599000;
  var KEY = 'mg_gift_state';
  if (Date.now() > END) return;

  var busy = false;
  var timer = null;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function read(k) { try { return window.sessionStorage.getItem(k) || ''; } catch (e) { return ''; } }
  function write(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }
  function getJSON(url) { return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function postJSON(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); });
  }
  function cartNow() { return getJSON(root + 'cart.js?_=' + Date.now()); }
  function giftLine(cart) { return cart.items.filter(function (i) { return i.variant_id === GIFT_VARIANT; })[0]; }
  function spend(cart) { return cart.items.reduce(function (s, i) { return i.variant_id === GIFT_VARIANT ? s : s + i.final_line_price; }, 0); }
  function removeLine(line) { return postJSON(root + 'cart/change.js', { id: line.key, quantity: 0 }); }

  // Same events the theme uses, so the drawer, the cart count and the cart page update by themselves.
  function refreshUI() {
    return cartNow().then(function (cart) {
      var ids = [];
      document.querySelectorAll('[section-id]').forEach(function (el) {
        var id = el.getAttribute('section-id');
        if (id && ids.indexOf(id) < 0) ids.push(id);
      });
      if (!ids.length) {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        return;
      }
      return getJSON(root + '?sections=' + ids.join(',')).then(function (sections) {
        cart.sections = sections;
        document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'line-item:change', cart: cart, mgGift: true } }));
      }, function () {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      });
    });
  }

  function sync() {
    if (busy) return;
    busy = true;
    var changed = false;
    cartNow().then(function (cart) {
      var total = spend(cart);
      var gift = giftLine(cart);
      var state = read(KEY);
      if (total >= THRESHOLD) {
        if (gift) return;
        if (state === 'added') { write(KEY, 'declined'); return; }
        if (state === 'declined') return;
        return postJSON(root + 'cart/add.js', { items: [{ id: GIFT_VARIANT, quantity: 1, properties: { _mg_free_gift: '1' } }] })
          .then(cartNow)
          .then(function (after) {
            changed = true;
            var g = giftLine(after);
            if (g && g.final_line_price > 0) { write(KEY, 'declined'); return removeLine(g); }
            write(KEY, 'added');
          });
      }
      if (state === 'declined') write(KEY, '');
      var autos = cart.items.filter(function (i) { return i.variant_id === GIFT_VARIANT && i.properties && i.properties._mg_free_gift; });
      if (autos.length) {
        var updates = {};
        autos.forEach(function (i) { updates[i.key] = 0; });
        return postJSON(root + 'cart/update.js', { updates: updates }).then(function () { write(KEY, ''); changed = true; });
      }
    }).catch(function () {}).then(function () {
      busy = false;
      if (changed) refreshUI().catch(function () {});
    });
  }

  function schedule() { clearTimeout(timer); timer = setTimeout(sync, 350); }

  document.addEventListener('cart:change', function (e) { if (!(e.detail && e.detail.mgGift)) schedule(); });
  document.addEventListener('cart:refresh', schedule);
  window.addEventListener('pageshow', schedule);
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-mg-add-gift]');
    if (b) { write(KEY, ''); sync(); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
})();
